export enum COLOR_PREFERENCES {
  PRIMARY = 'primary_color',
  SECONDARY = 'secondary_color',
  MENU = 'menu_color',
}

export interface Preference {
  key: COLOR_PREFERENCES;
  value: string;
}

export enum AccountSettingOption {
  RefuseQuotationsFromCustomerPortal = 'refuse_quotations_from_customer_portal',
}

export interface AccountSetting {
  // For now its null, in future this might change
  data: null;
  enabled: boolean;
  name: AccountSettingOption;
}
export type AccountSettings = AccountSetting[];

export interface CloudPlatform {
  preferences: Preference[];
  logo: string | null;
  paymentServiceProvidersEnabled: boolean;
  account_settings: AccountSettings;
}
